import React,{ Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
import DATEPICKER_OR from "../../../common/custom-form/custom-date-picker.component";
import { TabberButton } from "../../../common/custom-form/tabber-button.component";
import ButtonIcon from "../../../button"
import { InputGroup, FormControl, Button } from "react-bootstrap";
import InvoiceComment from "../../../common/report/reports/Invoice/manage-invoice/invoice-comment.component";
import { SelectField } from "../../../common/custom-form/select-filter.component";
import ManageLayout from "../../../common/report/details/manage-report.component";
import { OrderHistory } from "../order-summary/order-history.component";
import OrderCircuitDetails from "./order-circuit-detail.component";
import OrderSummary from "../order-summary/order-summary.component";
import { Selected_Index } from "../../../../constants/internal-constants";
export default class ManageOrder extends Component{
    constructor(props){
        super(props);
        this.getDataSelected=this.getDataSelected.bind(this);
        this.openCircuitView=this.openCircuitView.bind(this);
        this.state={
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
            filterSelected: "", 
            inputValue: "",
            invoiceDate: "",
            invoiceApproveDate: "",
            invoiceDueDate: "",
            billingPeriodDate: "",
            invoiceExpectedDate: "",
            rentalPeriodDate: "",
            actualInvoiceMonth: "",
            invoiceReceiptDate: "",
            beginDate: "",
            endDate: "",
            showOrderSummary: false,
            openCircuitDetails:false,
            dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ],
            selectedIndex:"0", 
            dataSelected:0,
            tableSelected:false,
            listTabInfo:{
                Tab:[
                    {
                        "id":"0",
                        "label":"Details"            
                    },
                    {
                        "id":"1",
                        "label":"History"           
                    },
                    {
                        "id":"2",
                        "label":"Comments"           
                    }
                ]
            },
            dataInfo:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            commentData:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0"                         
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[                         
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            statusList:[
                {
                    "status":"Order Created",
                    "dateCompleted": "29/09/2022"
                },
                {
                    "status":"Order Submitted"                
                },
                {
                    "status":"Order Receipt Confirmed"                    
                },
                {
                    "status":"Circuit Installed"                    
                }

            ]

        }
    }

    getDataSelected(data) {
        this.setState({selectedIndex:data})
       
    }

    openLineItem(data) {
        this.setState({tableSelected:data})
    }

    openCircuitView(value){
       
        this.setState({openCircuitDetails:value})   
        this.setState({showOrderSummary:false})  
        this.setState({selectedIndex:"0"})   
    }

     
    render(){   
        const {selectFilter,dataInfo,startDate,dataTable,listTabInfo,tableSelected,selectedIndex}=this.state;           
        return(
            <>
            {
                !this.state.showOrderSummary ?
                this.state.openCircuitDetails ? 
                <OrderCircuitDetails closeForm={this.openCircuitView}/>
                :
    
                <ManageLayout customClassName="manage-order-table" buttonLabel="Back"  haveStatusLabel={true} onGetSelected={this.getDataSelected.bind(this)} statusList={this.state.statusList} closeForm={this.props.closeForm} listData={listTabInfo.Tab} haveHeaderButton={false}>
    
                        {
                            selectedIndex===Selected_Index.i_Zero &&
                                <>
                                    <div className="manage-order-container">
                                        <div className="manage-order-detail">
                                            <InputField label="SR NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <SelectField label="ACCOUNT NUMBER"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                                            <InputField label="CARRIER TRACKING ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <InputField label="ORDER NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <SelectField label="END USER"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                                            <InputField label="ORDER COMPLETION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <InputField label="REQUESTOR" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <SelectField label="MANAGER APPROVER"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>   
                                            <SelectField label="APPROVAL STATUS"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                              
                                            <DATEPICKER_OR label="REQUESTED DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                                            <SelectField label="REQUEST TYPE"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                              
                                            <SelectField label="REQUEST SUB"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                              
                                            <SelectField label="VENDOR"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                              
                                            <InputField label="CONTRACT TERM" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <TabberButton label="Expedite Request"/>
                                            <SelectField label="STATUS"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>    
                                            <div></div>
                                            <ButtonIcon onClick={()=>this.setState({showOrderSummary:true})} iconLeft="file-lines" iconSize="17px" customClassName="order-summary-btn" labelName="Order Summary"/>                                   
                                        </div>
                                    </div>
                                    <div className="manage-order-container">
                                        <h1>Financial Information</h1>
                                        <div className="manage-order-detail">
                                            <InputField label="GL CODE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <InputField label="COST CENTER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <InputField label="APPROVER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <InputField label="BUSINESS JUSTIFICATION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <InputField label="ADDITIONAL INFORMATION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                        </div>
    
                                    </div>  
                                    <div className="manage-order-container">
                                        <h1>Location Information</h1>
                                        <div className="manage-order-detail">
                                            <div></div>
                                            <h1>Service Location 1</h1>
                                            <h1>Service Location 2</h1>
                                            <DATEPICKER_OR label="REQUESTED DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                                            <SelectField label="LOCATION ADDRESS (MANAGEMENT LOCATION)"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                          
                                            <SelectField label="LOCATION ADDRESS (MANAGEMENT LOCATION)"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                          
                                        
                                            <SelectField label="BILLING ADDRESS LOCATION"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                          
                                            <InputField label="SITE NAME (NON-MANANGED LOCATIONS)" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <InputField label="SITE NAME (NON-MANANGED LOCATIONS)" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                        </div>
                                        <h1>CONTACT INFORMATION</h1>
                                        <div className="horizontal-separator"></div>
                                            <div className="manage-order-detail">
                                                <InputField label="LOCAL CONTACT EMAIL ADDRESS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                                <InputField label="LOCAL CONTACT FULL NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                                <InputField label="LOCAL CONTACT PHONE NUMBERS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                                <InputField label="ALTERNATE LOCAL CONTACT EMAIL ADDRESS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                                <InputField label="ALTERNATE LOCAL CONTACT FULL NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                                <InputField label="ALTERNATE LOCAL CONTACT PHONE NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                                <SelectField label="TECHNICAL CONTACT EMAIL ADDRESS"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                          
                                                <SelectField label="TECHNICAL CONTACT FULL NAME"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                          
                                                <InputField label="TECHNICAL CONTACT PHONE NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                                <SelectField label="ALTERNATE TECHNICAL CONTACT EMAIL ADDRESS"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                          
                                                <SelectField label="ALTERNATE TECHNICAL CONTACT FULL NAME"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>  
                                                <InputField label="ALTERNATE TECHNICAL CONTACT PHONE NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
            
                                            </div>
                                    </div>    
                                    <div className="save-btn-container">
                                        <Button className="save-button"> Save Changes </Button>                                   
                                    </div>                                
                                </>
                        }
    
                        {
                            selectedIndex===Selected_Index.i_One &&
                            <OrderHistory openCircuitDetail={this.openCircuitView}/>
                            
                        }
    
                        {
                            selectedIndex===Selected_Index.i_Two &&
                            <InvoiceComment dataInfo={this.state.commentData}/>
                        }
    
                    </ManageLayout>
                :
                <OrderSummary closeForm={this.openCircuitView}/>
            }
           
            </>
        )
    }
}